import { CloudSync as SyncIcon } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

interface Props {
  lastSyncedAt: Date | null;
}

const formatter = new Intl.DateTimeFormat('ko-KR', {
  dateStyle: 'short',
  timeStyle: 'short',
});

/**
 * 마지막 데이터 동기화 시각 표시 (의뢰서 4-2).
 * 실제 데이터 소스는 P0-11 일간 집계 배치에서 연결.
 */
export function SyncStatus({ lastSyncedAt }: Props) {
  const formatted = lastSyncedAt ? formatter.format(lastSyncedAt) : '—';
  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ color: 'text.secondary' }}>
      <SyncIcon fontSize="small" sx={{ fontSize: 18 }} />
      <Typography variant="caption" noWrap>
        마지막 동기화: {formatted}
      </Typography>
    </Stack>
  );
}
